import last from "lodash/last";
import { useLocationSlugCollection } from "./useLocationSlugCollection";
interface LocationSlugResultInterface {
  slug: string;
}

export function useLocationSlug(): LocationSlugResultInterface {
  const splittedPathname = useLocationSlugCollection();
  const result = { slug: last(splittedPathname) || "" };
  return result;
}
